"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useToggle = function useToggle(state) {
  var _a = react_1.useState(state),
      value = _a[0],
      setValue = _a[1];

  var toggle = react_1.useCallback(function (nextValue) {
    if (typeof nextValue !== 'undefined') {
      setValue(!!nextValue);
      return;
    }

    setValue(function (value) {
      return !value;
    });
  }, [setValue]);
  return [value, toggle];
};

exports.default = useToggle;